module.exports = __webpack_public_path__ + "img/Google_Play.f41a8338.svg";